import React from 'react';

type GoogleIconProps = React.SVGProps<SVGSVGElement>;

const GoogleIcon: React.FC<GoogleIconProps> = (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 256 262"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <path
        d="M255.68 133.49c0-10.84-.97-21.23-2.79-31.26H130.51v59.17h70.22c-3.03 16.2-12.32 29.89-26.28 39.06v32.5h42.47c24.87-22.91 39.26-56.7 39.26-99.47z"
        fill="#4285F4"
      />
      <path
        d="M130.51 261c35.55 0 65.43-11.76 87.24-31.93l-42.47-32.5c-11.77 7.89-26.81 12.56-44.77 12.56-34.42 0-63.63-23.22-74.06-54.46H12.89v34.25C34.68 232.13 79.52 261 130.51 261z"
        fill="#34A853"
      />
      <path
        d="M56.45 154.67c-2.74-8.12-4.31-16.77-4.31-25.67s1.57-17.55 4.31-25.67V69.08H12.89C4.61 84.83 0 102.57 0 121.67c0 19.1 4.61 36.84 12.89 52.59l43.56-34.25z"
        fill="#FBBC05"
      />
      <path
        d="M130.51 51.07c19.38 0 36.73 6.67 50.46 19.75l37.83-37.83C195.94 13.08 166.06 0 130.51 0 79.52 0 34.68 28.87 12.89 69.08l43.56 34.25c10.43-31.24 39.64-54.26 74.06-54.26z"
        fill="#EA4335"
      />
    </svg>
  );
  
  export default GoogleIcon;